import { FilterWidgetWrapper } from 'src/pages/dashboard/features/filter-widget/FilterWidget';

import type { TWidgetRendererOptions } from './WidgetRendererService';
import type { ReactNode } from 'react';
import type { FilterWidgetEntity } from 'src/pages/dashboard/features/filter-widget/FilterWidget.entity';

export function renderWellsFilterWidget(widget: FilterWidgetEntity, options: TWidgetRendererOptions): () => ReactNode {
  return () => <FilterWidgetWrapper filterWidgetEntity={widget} options={options} />;
}
